import { Config, loadConfig } from 'services/loadConfig';

declare global {
  interface Window {
    wmpConfig: Config;
  }
}

loadConfig()
  .then(async (config) => {
    // Store config
    window.wmpConfig = config;

    // Defer all imports so that process.env is properly defined when importing
    const { boot } = await import('./boot');
    boot();
  })
  .catch((error) => console.error('Unable to load configuration file', error));
